// Material Dashboard 2 React layouts
import Dashboard from "layouts/dashboard";
import Jugadores from "layouts/jugadores/jugadoresList";
import EquiposDashboard from "layouts/equipos/equiposList";
import EntrenadoresList from "layouts/entrenadores/entrenadoresList";
import EntrenamientosList from "layouts/tables/data/entrenamientosList";
import HorariosList from "layouts/horarios/horariosList";
import PartidosList from "layouts/tables/data/partidosList";
import Perfil from "layouts/profile";
import Calendario from "layouts/calendario/calendario";
import SignIn from "layouts/authentication/sign-in";
import Clasification from "layouts/clasification/Clasification";
// @mui icons
import Icon from "@mui/material/Icon";
import LogoutComponent from "layouts/authentication/logout/logout";
// Lecture token and role from localStorage
import { jwtDecode } from "jwt-decode";

const resumenRoute = {
  type: "collapse",
  name: "Resumen",
  key: "dashboard",
  icon: <Icon fontSize="small">dashboard</Icon>,
  route: "/dashboard",
  component: <Dashboard />,
};

const equiposRoute = {
  type: "collapse",
  name: "Equipos",
  key: "equipos",
  icon: <Icon fontSize="small">diversity_3</Icon>,
  route: "/equipos",
  component: <EquiposDashboard />,
};

const entrenadoresRoute = {
  type: "collapse",
  name: "Entrenadores",
  key: "entrenadores",
  icon: <Icon fontSize="small">groups</Icon>,
  route: "/entrenadores",
  component: <EntrenadoresList />,
};

const jugadoresRoute = {
  type: "collapse",
  name: "Jugadores",
  key: "jugadores",
  icon: <Icon fontSize="small">supervisor_account</Icon>,
  route: "/jugadores",
  component: <Jugadores />,
};

const entrenamientosRoute = {
  type: "collapse",
  name: "Entrenamientos",
  key: "entrenamientos",
  icon: <Icon fontSize="small">fitness_center</Icon>,
  route: "/entrenamientos",
  component: <EntrenamientosList />,
};

const horariosRoute = {
  type: "collapse",
  name: "Horarios",
  key: "horarios",
  icon: <Icon fontSize="small">schedule</Icon>,
  route: "/horarios",
  component: <HorariosList />,
};

const partidosRoute = {
  type: "collapse",
  name: "Partidos",
  key: "partidos",
  component: <PartidosList />,
  route: "/partidos",
  noCollapse: true,
  icon: <Icon fontSize="small">sports_soccer</Icon>,
};

const calendarioRoute = {
  type: "collapse",
  name: "Calendario",
  key: "calendario",
  icon: <Icon fontSize="small">calendar_today</Icon>,
  route: "/calendario",
  component: <Calendario />,
};

const clasificacionRoute = {
  type: "collapse",
  name: "Clasificación",
  key: "clasificacion",
  icon: <Icon fontSize="small">emoji_events</Icon>,
  route: "/clasificacion",
  component: <Clasification />,
};

// Enlace externo directo al portal de participantes del IMD (no es una
// pantalla propia de Convokko, se abre en una pestaña nueva).
const imdRoute = {
  type: "collapse",
  name: "IMD Sevilla",
  key: "imd",
  icon: <Icon fontSize="small">open_in_new</Icon>,
  route: "https://imd.sevilla.org/app/jjddmm_participantes/",
  external: true,
};

// Sin "type: collapse": no aparece en el Sidenav, solo se accede desde el
// desplegable de usuario del navbar.
const perfilRoute = {
  name: "Mi perfil",
  key: "perfil",
  route: "/perfil",
  component: <Perfil />,
};

const logoutRoute = {
  type: "collapse",
  name: "Cerrar Sesión",
  key: "sign-out",
  icon: <Icon fontSize="small">logout</Icon>,
  route: "/logout",
  component: <LogoutComponent />,
};

const getAppRoutes = () => {
  const token = localStorage.getItem("token");
  let rol = null;

  if (token) {
    try {
      const decoded = jwtDecode(token);
      rol = decoded.rol;
    } catch (error) {
      console.error("Error decodificando token:", error);
    }
  }

  const commonRoutes = [
    resumenRoute,
    jugadoresRoute,
    entrenamientosRoute,
    horariosRoute,
    partidosRoute,
    calendarioRoute,
    clasificacionRoute,
    imdRoute,
    perfilRoute,
    logoutRoute,
  ];

  if (rol === "coordinador") {
    // Insertar Equipos y Entrenadores después de Resumen
    return [
      resumenRoute,
      equiposRoute,
      entrenadoresRoute,
      ...commonRoutes.slice(1), // sin duplicar "Resumen"
    ];
  }

  return commonRoutes;
};

export default getAppRoutes;
